import React from 'react';
import { useAuth } from '../context/AuthContext';
import Layout from '../components/Layout/Layout';

// Componentes modulares
import DocumentAccordion from '../components/Configuration/DocumentAccordion';
import DocumentModal from '../components/Configuration/DocumentModal';
import TemplateModal from '../components/Configuration/TemplateModal';
import ConfigurationHeader from '../components/Configuration/ConfigurationHeader';
import EmptyState from '../components/Configuration/EmptyState';
import LoadingSpinner from '../components/Configuration/LoadingSpinner';

// Hooks personalizados
import { useConfiguration, useConfigurationActions } from '../hooks/useConfiguration';

// Estilos
import '../styles/ModularComponents.css';

const Configuracion = () => {
  const { user } = useAuth();
  
  // Hook de configuración principal
  const configState = useConfiguration(user);
  
  // Hook de acciones
  const actions = useConfigurationActions(user, configState);

  return (
    <Layout>
      <div className="row">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <h1 className="h3 mb-1">Configuración del Sistema</h1>
              <p className="text-muted">Gestione los tipos de documentos y sus campos de captura</p>
            </div>        
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="card border-0 shadow-sm">
            <ConfigurationHeader
              user={user}
              loading={configState.loading}
              onOpenTemplateModal={actions.openTemplateModal}
              onInitializeDefaultData={actions.handleInitializeDefaultData}
              onOpenAddModal={actions.openAddModal}
            />
            <div className="card-body">
              {configState.loading ? (
                <LoadingSpinner />
              ) : configState.documentTypes.length === 0 ? (
                <EmptyState
                  user={user}
                  onOpenAddModal={actions.openAddModal}
                  onOpenTemplateModal={actions.openTemplateModal}
                />
              ) : (
                <DocumentAccordion
                  documentTypes={configState.documentTypes}
                  openAccordion={configState.openAccordion}
                  setOpenAccordion={configState.setOpenAccordion}
                  user={user}
                  onEditDocument={actions.openEditModal}
                  onDeleteDocument={actions.handleDeleteDocument}
                  onDeleteField={actions.handleDeleteField}
                  onUpdateField={actions.handleUpdateFieldInline}
                  onRefreshData={configState.loadDocumentTypes}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Modales */}
      <DocumentModal
        show={configState.showAddModal}
        mode="add"
        user={user}
        documentForm={configState.documentForm}
        setDocumentForm={configState.setDocumentForm}
        onClose={() => configState.setShowAddModal(false)}
        onSubmit={actions.handleAddDocument}
      />

      <DocumentModal
        show={configState.showEditModal}
        mode="edit"
        user={user}
        documentForm={configState.documentForm}
        setDocumentForm={configState.setDocumentForm}
        onClose={() => configState.setShowEditModal(false)}
        onSubmit={actions.handleEditDocument}
      />

      <TemplateModal
        show={configState.showTemplateModal}
        publicTemplates={configState.publicTemplates}
        loadingTemplates={configState.loadingTemplates}
        selectedTemplate={configState.selectedTemplate}
        setSelectedTemplate={configState.setSelectedTemplate}
        newDocumentName={configState.newDocumentName}
        setNewDocumentName={configState.setNewDocumentName}
        onClose={() => configState.setShowTemplateModal(false)}
        onSubmit={actions.handleCreateFromTemplate}
      />
    </Layout>
  );
};

export default Configuracion;
